import { Component, effect, ElementRef, EventEmitter, OnInit, Output, Renderer2 } from '@angular/core';
import { PermissionStatus } from 'src/app/models/permissions.model';
import { ClipboardService } from 'src/app/services/clipboard.service';

@Component({
  selector: 'tx-ribbon-clipboard-paste',
  templateUrl: './ribbon-clipboard-paste.component.html',
  styleUrl: './ribbon-clipboard-paste.component.scss'
})
export class RibbonClipboardPasteComponent {

  @Output() pasteButtonClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(private renderer: Renderer2, private el: ElementRef, private clipboardService: ClipboardService) {
    // effect(() => {
    //   this.checkPermission();
    // })
  }

  public checkPermission() {
    if (this.clipboardService.permission() === PermissionStatus.Denied) {
      this.displayDefaultButton();
    } else {
      this.displayCustomPasteButton();
    }
  }

  displayCustomPasteButton() {
    const ribbonGroupClipboard = this.el.nativeElement.closest('tx-edit-document')
        .querySelector('#ribbonGroupClipboard') as HTMLElement;

    if (ribbonGroupClipboard) {
      const ribbonContentGroup = ribbonGroupClipboard.querySelector('.ribbon-group-content');

      if (!ribbonContentGroup) {
        return;
      }

      let pasteImageSrc = '';
      // hide default paste button
      const defaultPasteButton = ribbonGroupClipboard.querySelector('#ribbonTabHome_btnServerPaste');
      if (defaultPasteButton) {
        const defaultPasteButtonImage = defaultPasteButton.querySelector('.ribbon-button-big-image');
        if (defaultPasteButtonImage) {
          pasteImageSrc = defaultPasteButtonImage.getAttribute('src') ?? '';
        }

        this.renderer.setStyle(defaultPasteButton, 'display', 'none');
      }

      let ribbonTabHomeBtnPaste = ribbonContentGroup.querySelector('#ribbonTabHome_btnPaste');
      // if it exists, just set display to block
      if (ribbonTabHomeBtnPaste) {
        this.renderer.setStyle(ribbonTabHomeBtnPaste, 'display', 'block');
      } else {
        // create the button
        ribbonTabHomeBtnPaste = this.renderer.createElement('div');
        this.renderer.setAttribute(ribbonTabHomeBtnPaste, 'id', 'ribbonTabHome_btnPaste');
        this.renderer.addClass(ribbonTabHomeBtnPaste, 'ribbon-button');
        this.renderer.addClass(ribbonTabHomeBtnPaste, 'ribbon-button-big');
        const ribbonContentGroupFirstChild = ribbonContentGroup.firstElementChild;
        this.renderer.insertBefore(ribbonContentGroup, ribbonTabHomeBtnPaste, ribbonContentGroupFirstChild);
        ribbonTabHomeBtnPaste?.addEventListener('click', this.onPasteButtonClicked.bind(this));
  
        // add image container
        const imageContainer = this.renderer.createElement('div');
        this.renderer.addClass(imageContainer, 'ribbon-button-big-image-container');
        this.renderer.appendChild(ribbonTabHomeBtnPaste, imageContainer);
  
        // add image
        const image = this.renderer.createElement('img');
        this.renderer.addClass(image, 'ribbon-button-big-image');
        this.renderer.setAttribute(image, 'src', pasteImageSrc);
        this.renderer.setStyle(image, 'height', '32px');
        this.renderer.setStyle(image, 'width', '32px');
        this.renderer.appendChild(imageContainer, image);
  
        // add label container
        const labelContainer = this.renderer.createElement('div');
        this.renderer.addClass(labelContainer, 'ribbon-button-big-label-container');
        this.renderer.appendChild(ribbonTabHomeBtnPaste, labelContainer);
  
        // add label paragraph
        const labelParagaph = this.renderer.createElement('p');
        this.renderer.addClass(labelParagaph, 'ribbon-button-label');
        this.renderer.setAttribute(labelParagaph, 'id', 'ribbonTabHome_btnPaste_caption');
        this.renderer.appendChild(labelContainer, labelParagaph);
  
        // add label text
        const labelText = this.renderer.createElement('span');
        this.renderer.addClass(labelText, 'ribbon-button-label-text');
        const text = this.renderer.createText('Paste');
        this.renderer.appendChild(labelText, text);
        this.renderer.appendChild(labelParagaph, labelText);
      }
    }
  }

  onPasteButtonClicked(e: any) {
    this.pasteButtonClicked.emit(e);
  }

  private displayDefaultButton() {
    const ribbonGroupClipboard = this.el.nativeElement.closest('tx-edit-document')
        .querySelector('#ribbonGroupClipboard') as HTMLElement;

    if (ribbonGroupClipboard) {
      // display default button
      const defaultPasteButton = ribbonGroupClipboard.querySelector('#ribbonTabHome_btnServerPaste');
      if (defaultPasteButton) {
        this.renderer.setStyle(defaultPasteButton, 'display', 'block');
      }

      // hide custom button
      const customPasteButton = ribbonGroupClipboard.querySelector('#ribbonTabHome_btnPaste');
      if (customPasteButton) {
        this.renderer.setStyle(customPasteButton, 'display', 'none');
      }
    }
  }
}
